export default __webpack_public_path__ + "static/media/BR - Network Packet Analysis.5d45d3ef.png";